export default {"src":"/_next/static/media/dark.bb13e48d.svg","height":96,"width":733,"blurWidth":0,"blurHeight":0};